import { useMutation, useQueryClient } from 'react-query';
import { disableUserOtp, DisableUserOtpParams } from '../../api';

export const useDisableUserOtp = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (variables: DisableUserOtpParams) => disableUserOtp(variables),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`users`, projectId]);
      },
    },
  );
};
